import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  IconButton,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import AgreementCreate from "../../AgreementCreate";
import ReplayIcon from "@material-ui/icons/Replay";
import Tooltip from "@material-ui/core/Tooltip";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { ResultEnum, Role } from "../../../../enums/enums";
import { useSelector } from "react-redux";

export default function TableMultiple({
  setIsLoading,
  setDataToast,
  data,
  reload,
}) {
  const [reprocessAgreementDialog, setReprocessAgreementDialog] = useState({
    open: false,
  });
  const [idExternalAgreement, setIdExternalAgreement] = useState();
  const [isAdmin, setIsAdmin] = useState();
  
  const { decoded } = useSelector((state) => state.authReducer);

  function openReprocessModal(e) {
    setIsLoading(true);
    setIdExternalAgreement(e);
    setReprocessAgreementDialog({ open: true });
  }

  function closeReprocessModal() {
    setReprocessAgreementDialog({ open: false });
    reload();
  }

  useEffect(() => {
    setIsLoading(true);

    let role = decoded.role;
    setIsAdmin(role === Role.AdminComercial ?? false);
    setIsLoading(false);
  });

  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className="c-w-10 c-size-custom">Fecha de Proceso</TableCell>
              <TableCell className={`c-w-5`}>N° Registro</TableCell>
              <TableCell className={`c-w-5`}>Estado</TableCell>
              <TableCell className={`c-w-5`}>N° Contrato</TableCell>
              <TableCell className={`c-w-25`}>Cliente</TableCell>
              <TableCell className={`c-w-5`}>Documento</TableCell>
              <TableCell className={"c-w-15"}>Producto</TableCell>
              <TableCell className={"c-w-15"}>Categoría</TableCell>
              <TableCell className={`c-w-15`}>Opciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(({ id, processDate, customer, product, agreementId, documentNumber, status, categoryName }) => (
              <TableRow key={id}>
                <TableCell className="c-w-10">{processDate}</TableCell>
                <TableCell className="c-w-5">{id}</TableCell>

                <Tooltip title="Indica si el contrato esta confirmado." arrow>
                  {status === ResultEnum.Fail ? (
                    <TableCell className="c-w-5">
                      <CloseIcon style={{ color: "red" }}></CloseIcon>
                    </TableCell>
                  ) : (
                    <TableCell className="c-w-5">
                      <CheckIcon style={{ color: "green" }}></CheckIcon>
                    </TableCell>
                  )}
                </Tooltip>
                <TableCell className="c-w-5">{agreementId}</TableCell>
                <TableCell className="c-w-25">{customer}</TableCell>
                <TableCell className="c-w-5">{documentNumber}</TableCell>
                <TableCell className="c-w-15">{product}</TableCell>
                <TableCell className="c-w-15">{categoryName}</TableCell>
                <TableCell className="c-w-15 c-table-small-padding">
                  {status === ResultEnum.Fail && !isAdmin && (
                    <Tooltip title="Reprocesar">
                      <IconButton className="c-grid-btn-info button-grid" onClick={() => openReprocessModal(id)}>
                        <ReplayIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div>
        {reprocessAgreementDialog["open"] && (
          <Dialog
            open={reprocessAgreementDialog}
            onClose={() => setReprocessAgreementDialog({ open: false })}
            maxWidth={true}
            fullWidth={true}
          >
            <DialogContent>
              <AgreementCreate
                setIsLoading={setIsLoading}
                setDataToast={setDataToast}
                externalAgreementId={idExternalAgreement}
                onClose={() => closeReprocessModal()}
              />
            </DialogContent>
          </Dialog>
        )}
      </div>
    </>
  );
}
